import { useSearchParams } from "react-router-dom";
import classNames from "classnames";

type TabProps = {
  label: string;
  value: string;
};
const Tabs = ({
  tabs,
  className,
}: {
  tabs: TabProps[];
  className?: string;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get("tab") ?? "";

  const click = (value: string) => () => {
    searchParams.forEach((value, key) => {
      if (key !== "tab") {
        searchParams.delete(key);
      }
    });

    setSearchParams((params) => {
      value === "" ? params.delete("tab") : params.set("tab", value);
      return params;
    });
  };

  return (
    <div
      className={classNames(
        "flex w-full overflow-x-scroll no-scrollbar mt-4",
        className
      )}
    >
      <Pad />
      {tabs.map((tab, i) => (
        <Tab
          key={i}
          tab={tab}
          selected={value === tab.value}
          onClick={click(tab.value)}
        />
      ))}
      <div className="flex-1 border-b border-slate-500 min-w-16" />
    </div>
  );
};

export default Tabs;

const Tab = ({
  tab,
  selected,
  onClick,
}: {
  tab: TabProps;
  selected: boolean;
  onClick: () => void;
}) => {
  return (
    <div className="flex">
      <Pad />
      <div
        className={classNames(
          "py-1.5 px-5 border cursor-pointer rounded-t-lg font-semibold whitespace-nowrap text-sm",
          {
            "border-slate-500 border-b-white bg-white -mb-[1px]": selected,
            "border-transparent border-b-slate-500 bg-slate-100": !selected,
          }
        )}
        onClick={onClick}
      >
        {tab.label}
      </div>
    </div>
  );
};

const Pad = () => <div className="w-2 border-b border-slate-500" />;
